<template>
    <section class="step-item step-groups">
        <section class="step-item__title">
            <h2>Grupy i kontakty</h2>
        </section>
        <section class="step-item__body">
            <section class="step-item__body__item flex-column">
                <p>Wybierz grupy, które chcesz skopiować do nowej kadencji:</p>
                <section v-for="(item, index) in getSessionGroups" :key="index">
                    <CheckBoxButton :id="item.id"
                                    :value="item.id"
                                    @setGroupId="(val) => ($store.state.wizardNewCadence.selectedGroups = val)"
                                    :idsArray="$store.state.wizardNewCadence.selectedGroups"
                                    :checked="$store.state.wizardNewCadence.selectedGroups.indexOf(item.id) !== -1" />
                    <label :for="item.id" style="cursor: pointer">{{ item. name }}</label>
                </section>
            </section>
            <section class="step-item__body__item flex-column">
                <p>Pozostałe grupy:</p>
                <section v-for="(item, index) in getOthersGroup" class="other-groups" :key="index">
                    <section class="other-groups__item">
                        <CheckBoxButton :id="item.id"
                                        :value="item.id"
                                        @setGroupId="(val) => ($store.state.wizardNewCadence.selectedGroups = val)"
                                        :idsArray="$store.state.wizardNewCadence.selectedGroups"
                                        :checked="$store.state.wizardNewCadence.selectedGroups.indexOf(item.id) !== -1" />
                        <label :for="item.id" style="cursor: pointer">{{ item. name }}</label>
                    </section>
                    <section class="other-groups__contact" :class="{'half-hidden': $store.state.wizardNewCadence.selectedGroups.indexOf(item.id) === -1 }">
                        <CheckBoxButton :id="`base-${item.id}`"
                                        :value="item.id"
                                        @setGroupId="(val) => ($store.state.wizardNewCadence.selectedContactGroups = val)"
                                        :idsArray="$store.state.wizardNewCadence.selectedContactGroups"
                                        :checked="$store.state.wizardNewCadence.selectedContactGroups.indexOf(item.id) !== -1"
                                        :disabled="$store.state.wizardNewCadence.selectedGroups.indexOf(item.id) === -1"/>
                        <label :for="`base-${item.id}`" style="cursor: pointer">wraz z bazą kontaktów ({{item.availablePeople.length}})</label>
                    </section>
                </section>
            </section>
        </section>
        <section class="step-item__footer justify-content-end">
            <ButtonIconAppend :icon="'additional-arrow'" class="btn-step-item" @click="moveNext">
                Dalej
            </ButtonIconAppend>
        </section>
    </section>
</template>
<script charset="utf-8">
    import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
    import CheckBoxButton from "../../../BasicControls/CheckBoxButton.vue";
    import ButtonIconAppend from "../../../BasicControls/ButtonIconAppend.vue";

    export default {
        name: "Step1SelectCurrentGroups",
        components: {
            CheckBoxButton,
            ButtonIconAppend
        },
        computed: {
            getSessionGroups() {
                return this.$store.state.wizardNewCadence.availableGroups.filter(item => item.isSessions === true);
            },
            getOthersGroup() {
                return this.$store.state.wizardNewCadence.availableGroups.filter(item => item.isSessions === false);
            }
        },
        async mounted() {
            try {
                this.$store.commit("setWizardNewCadenceBusyStatus", true);
                this.$store.commit("setWizardNewCadenceCurrentStep", 1);
                await this.internalFetchAvailableGroups();
            }
            finally {
                this.$store.commit("setWizardNewCadenceBusyStatus", false);
            }
        },
        methods: {
            async internalFetchAvailableGroups() {
                let response = await wizardNewCadenceService.getAvailableGroups();
                if (response.status === 200)
                    this.$store.state.wizardNewCadence.availableGroups = response.data;

            },

            async moveNext() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    this.$store.commit("setWizardNewCadenceStepsDone", 1);
                    this.$store.commit("setWizardNewCadenceStepsDone", 2);

                    if (this.$store.state.wizardNewCadence.clientHasTransmission) {
                        await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 3 } });
                        this.$store.commit("setWizardNewCadenceCurrentStep", 3);
                    }
                    else {
                        await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 3 } });
                        this.$store.commit("setWizardNewCadenceCurrentStep", 3);
                    }
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "@/assets/scss/wizard-generic-step.scss";
    .step-item__body__item {
        .other-groups {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            row-gap: 5px;
            &__contact{
                margin-left: 30px;
            }
        }
    }
</style>